import React, { Component } from 'react';
import {
   Col, Card, CardBody, Table, Button, Row,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Moment from 'moment';
import CalendarIcon from 'mdi-react/CalendarIcon';
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/lib/Async';
import SelectService from '../../../services/SelectService';
import ViewChequeModal from '../../../shared/modals/ViewChequeModal';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class ReceivableReport extends Component {
   constructor() {
      super();
      this.state = {
         list: [],
         formdata: {
            locationId: '',
         },
         modal: false,
         totalReceivables: 0,
         goTo: false,
         lastPageVisited: window.history.state !== null ? window.history.state.state.prevpage : '',
      };
      this.userdata = JSON.parse(localStorage.getItem('userData'));
      this.searchTransaction = this.searchTransaction.bind(this);
      this.toggleModal = this.toggleModal.bind(this);
      this.paymentid = 0;
   }

   componentDidMount() {
      this.isLoading = true;
      this.loadCollectionList();
   }

   loadCollectionList = async (inventoryDateFrom = '', inventoryDateTo = '', locationID = '') => {
      try {
         const invDateFrom = inventoryDateFrom !== '' ? inventoryDateFrom : Moment(new Date()).format('YYYY-MM-DD');
         const invDateTo = inventoryDateTo !== '' ? inventoryDateTo : Moment(new Date()).format('YYYY-MM-DD');
         const locID = locationID !== '' ? `/locationid/${locationID}` : '';

         const response = await CommonService.getRows(`receivablereport/inventoryfrom/${invDateFrom}/inventoryto/${invDateTo}${locID}`);
         if (response) {
            this.setState({ list: response.list, totalReceivables: response.total_receivable });
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }
   }

   goBack = () => {
      this.setState({ goTo: true });
   }

   getLocations = async (newValue) => {
      this.isLoading = true;
      const formData = { searchFor: newValue, searchType: 9 };
      const options = [];
      if (this.isLoading) {
        await SelectService.listLocationOptions(formData).then((response) => {
          if (response) {
            response.map(opt => (
              options.push({
                value: opt.location_id,
                label: opt.location_name,
              })
            ));
          }
        }).catch((error) => {
          console.log('Error: ', error.message);
        });
        this.isLoading = false;
      }

      return options;
    }

   handleChange = (e, fieldName) => {
      if (fieldName === 'fromDate') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           fromDate: date,
         },
       }));
     } else if (fieldName === 'inventoryDateFrom') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           inventoryDateFrom: date,
         },
       }));
     } else if (fieldName === 'inventoryDateTo') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           inventoryDateTo: date,
         },
       }));
     } else if (fieldName === 'locationid') {
         let locationId = '';
         if (e) {
            locationId = e.value;
         }

         this.setState(prevState => ({
           formdata: { ...prevState.formdata, locationId },
         }));
     } else {
       const { name, value } = e.target;
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, [name]: value },
       }));
     }
   }

   viewChequeDetails = (e, paymentID = '') => {
    e.preventDefault();
    this.paymentid = paymentID;
    this.toggleModal();
   }

   toggleModal() {
    this.setState(prevState => ({ modal: !prevState.modal }));
   }

   searchTransaction(e) {
      e.preventDefault();
      const { formdata } = this.state;
      const inventoryDateFrom = Moment(formdata.inventoryDateFrom).format('YYYY-MM-DD');
      const inventoryDateTo = Moment(formdata.inventoryDateTo).format('YYYY-MM-DD');
      this.loadCollectionList(inventoryDateFrom, inventoryDateTo, formdata.locationId);
   }

   render() {
      const {
         list, goTo, lastPageVisited, formdata, totalReceivables, modal,
      } = this.state;

      if (goTo === true) {
         return <Redirect to={{ pathname: lastPageVisited }} />;
      }

      if (this.userdata.type !== '1') {
         return <Redirect to="/dashboard" />;
      }

      let inventoryDateFrom = new Date();
      if (formdata.inventoryDateFrom) {
        inventoryDateFrom = new Date(formdata.inventoryDateFrom);
      }

      let inventoryDateTo = new Date();
      if (formdata.inventoryDateTo) {
        inventoryDateTo = new Date(formdata.inventoryDateTo);
      }

      return (
         <Col md={12}>
            <ViewChequeModal
                modal={modal}
                toggle={this.toggleModal}
                chequeid={this.paymentid}
            />
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                     <h5 className="bold-text">Account Receivable Table</h5>
                     <div className="panel__btns">
                     {
                        lastPageVisited !== '' ? (
                           <Button onClick={this.goBack} className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" size="sm" outline>
                           <i className="fa fa-arrow-left" />
                           <span>Back</span>
                           </Button>
                        ) : ''
                     }
                     </div>
                  </div>
                  <Row className="m-0">
                     <Col md={12} className="m-b-20">
                        <form className="form form--horizontal the_form_display" onSubmit={this.searchTransaction}>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Location:</span>
                                 <div className="form__form-group-icon mh-38"><i className="fa fa-map-marker-alt" /></div>
                                 <AsyncSelect
                                    name="locationid"
                                    cacheOptions
                                    loadOptions={this.getLocations}
                                    defaultOptions
                                    isClearable
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    placeholder="Location name..."
                                    onChange={e => this.handleChange(e, 'locationid')}
                                 />
                              </div>
                           </div>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Date From:</span>
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <DatePicker
                                    name="inventoryDateFrom"
                                    selected={inventoryDateFrom}
                                    popperPlacement="top-end"
                                    onChange={e => this.handleChange(e, 'inventoryDateFrom')}
                                 />
                              </div>
                           </div>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Date To:</span>
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <DatePicker
                                    name="inventoryDateTo"
                                    selected={inventoryDateTo}
                                    popperPlacement="top-end"
                                    onChange={e => this.handleChange(e, 'inventoryDateTo')}
                                 />
                                 <button type="submit" className="form__form-group-button bg-primary">Search</button>
                              </div>
                           </div>
                        </form>
                     </Col>
                  </Row>
                  <div className="panel__content">
                  <h3>Total Receivables: {totalReceivables <= 0 ? <span className="text-red">&#x20B1; {global.numberFormat(totalReceivables)}</span> : <span className="text-green">&#x20B1; {global.numberFormat(totalReceivables)}</span>}</h3>
                  <Table responsive striped className="border-top">
                     <thead className="th-vtop">
                        <tr>
                           <th>Transaction #</th>
                           <th>Customer</th>
                           <th>Location</th>
                           <th>Total Sales</th>
                           <th>Amount Paid</th>
                           <th>Balance</th>
                           <th>Date</th>
                           {/* <th>Action</th> */}
                        </tr>
                     </thead>
                     <tbody>
                        {
                           list.length > 0 ? list.map((item) => {
                                const SalesDate = Moment(item.sales_date).format('MMMM DD, YYYY');
                                const SalesTotal = global.parseToNumber(item.total);
                                const AmountPaid = global.parseToNumber(item.amount_paid);
                                const SalesBalance = global.parseToNumber(item.balance);

                                return (
                                 <tr key={item.sales_id} className="text-center">
                                    <td className="text-left">{item.dr_number}</td>
                                    <td className="text-left">{item.customer_name}</td>
                                    <td className="text-left">{item.location_name}</td>
                                    <td className="text-left">&#x20b1; {global.numberFormat(SalesTotal)}</td>
                                    <td className="text-left">&#x20b1; {global.numberFormat(AmountPaid)}</td>
                                    <td className="text-left">&#x20b1; {global.numberFormat(SalesBalance)}</td>
                                    <td className="text-left">{SalesDate}</td>
                                    {/* <td className="text-left">
                                        {
                                            (item.payment_type === '1') ? (
                                                <Button color="primary" className="btn-xs" onClick={e => this.viewChequeDetails(e, item.payment_id)} outline><span className="fa fa-eye" /></Button>
                                            ) : ''
                                        }
                                    </td> */}
                                 </tr>
                              );
                           }) : (
                              <tr className="text-center">
                                 <td colSpan="8">No data available..</td>
                              </tr>
                           )
                        }
                     </tbody>
                  </Table>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(ReceivableReport);
